import React from "react";
import { ImageContainer } from "web/react/emo/image-container";

interface LystNewsImageProps {
    src: string;
}

export function LystNewsImage({ src }: LystNewsImageProps): React.ReactElement {
    return <ImageContainer key={src} width="100%" imageSrc={src} alt="" imageCredit={null} />;
}
